import { useId, useState } from "react";
import styles from "./DataPanel.module.css";
import classNames from "classnames";
import downArrowIcon from "../../assets/double-down.svg";
import DataPanelContent from "./DataPanelContent";
import { GetAccountDetailsResponse } from "../../lib/api/models";

const strings = {
  title: "CDP VDP",
};

type Props = {
  accountDetails: GetAccountDetailsResponse;
};

export default function DataPanel(props: Props) {
  const contentId = useId();

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.container}>
      <div
        id={contentId}
        className={classNames(styles.content, {
          [styles.expanded]: isExpanded,
        })}
      >
        <DataPanelContent {...props} />
      </div>
      <button
        className={styles.button}
        aria-controls={contentId}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((v) => !v)}
      >
        <img className={styles.expandCollapseIcon} src={downArrowIcon} alt="" />
        <span>{strings.title}</span>
        <img className={styles.expandCollapseIcon} src={downArrowIcon} alt="" />
      </button>
    </div>
  );
}
